import posthog from "posthog-js";
import { identify as posthog__identify } from "@/helpers/posthog";

import companyService from "@/services/company";
import serviceHandler from "@/helpers/handlers/service";
import { AccountType } from "@/enums/account-type";
import { LOCAL_STORAGE_KEYS } from "@/enums/local-storage";

const isWizardCompleted = companies => {
  if (
    companies.length &&
    (companies.every(
      company => company.company_user.type !== AccountType.OWNER
    ) ||
      companies.findIndex(
        company =>
          company.company_user.type === AccountType.OWNER &&
          company.is_master &&
          company.wizard_completed
      ) > -1)
  ) {
    return true;
  }

  if (companies.length === 1) {
    return companies[0].wizard_completed;
  }

  return !!companies.length;
};

export default {
  async fetchCategories({ commit }) {
    return await serviceHandler(companyService.getCategories()).then(item => {
      commit("SET_CATEGORIES", item);
    });
  },

  async fetchCompanies({ dispatch }) {
    const result = await serviceHandler(companyService.getCompanies());
    dispatch("setCompanies", result || []);
  },

  async setCompanyParent({ state, commit }, companyId) {
    const result = await serviceHandler(
      companyService.getCompanyParent(companyId)
    );
    commit("SET_PARENT", { id: state.company.parent, ...result });
  },

  async clearCompanyParent({ state, commit }) {
    commit("SET_PARENT", null);
  },

  async fetchCompanyStatus({ state, commit, dispatch }) {
    if (state.id) {
      return state;
    }
    dispatch("fetchCompanies");
  },

  async setWizardCompletionStatus({ state, commit }, status) {
    await serviceHandler(
      companyService.patchCompanyData({ wizard_completed: status }, state.id)
    );

    commit("SET_WIZARD_COMPLETION_STATUS", status);
  },

  setCompanyId({ commit }, payload) {
    commit("SET_COMPANY_ID", payload);
  },

  setCompanyById({ state, dispatch }, companyId) {
    const company = state.companies.find(({ id }) => id === companyId);

    if (company) {
      dispatch("setCompany", { company });
    }
  },

  setCompany({ commit }, { company, posthogIdentify = false }) {
    if (posthogIdentify) {
      posthog__identify(company.company_user.user_id);
    }

    posthog.people.set({
      company_id: `${company.id}`,
      parent_id: company.parent ? `${company.parent}` : null
    });

    commit("SET_COMPANY", company);
  },

  async updateCurrentCompany({ state, dispatch }) {
    const data = await serviceHandler(companyService.getCompany());

    if (data.length && state.company && state.company.id) {
      const company = data.find(company => company.id === state.company.id);

      if (company) {
        dispatch("setCompany", { company });
      }
    }
  },

  setCompanies({ state, dispatch, commit }, payload) {
    commit("SET_COMPANIES", payload);
    const savedCompanyId = localStorage.getItem(LOCAL_STORAGE_KEYS.COMPANY_ID);
    const savedCompany = savedCompanyId
      ? state.companies.find(({ id }) => id === +savedCompanyId)
      : null;

    if (savedCompanyId && savedCompany) {
      dispatch("setCompany", { company: savedCompany, posthogIdentify: true });
    } else if (!state.company && payload.length) {
      localStorage.setItem(LOCAL_STORAGE_KEYS.COMPANY_ID, payload[0].id);
      dispatch("setCompany", { company: payload[0], posthogIdentify: true });
    } else if (state.company && state.company.id) {
      const company = state.companies.find(({ id }) => id === state.company.id);
      dispatch("setCompany", {
        company: company || payload[0],
        posthogIdentify: true
      });
    }
    commit("SET_WIZARD_COMPLETION_STATUS", isWizardCompleted(payload));
  }
};
